import React from "react";
import Swiper from "react-id-swiper";
// SCSS
import "swiper/css/swiper.css";
import PartnerBox from "./partnerBox";
// Assets
import Partner01 from "../../assets/partners/fifa.png";
import Partner02 from "../../assets/partners/FRMF.png";
import Partner03 from "../../assets/partners/afc.png";
import Partner04 from "../../assets/partners/laliga.png";

class MutipleSlidesPerView extends React.Component {
  state = {
    partners: [
      {
        preview: Partner01,
        id: "1",
      },
      {
        preview: Partner02,
        id: "2",
      },
      {
        preview: Partner03,
        id: "3",
      },
      {
        preview: Partner04,
        id: "4",
      },
     
    ],
  };

  render() {
    let partnersRender = null;

    if (this.state.partners) {
      partnersRender = this.state.partners.map((partner) => (
        <div key={partner.id}>
          <PartnerBox partner={partner.preview} />
        </div>
      ));
    }

    const params = {
      slidesPerView: 3,
      spaceBetween: 20,
      loop: true,
     
      breakpoints: {
        1200: {
          slidesPerView: 6,
          spaceBetween: 40,
        },
        1024: {
          slidesPerView: 5,
          spaceBetween: 40,
        },
        768: {
          slidesPerView: 4,
          spaceBetween: 30,
        },
        640: {
          slidesPerView: 3,
          spaceBetween: 20,
        },
        320: {
          slidesPerView: 2,
          spaceBetween: 10,
        },
      },
    };
    
    return (
      <Swiper {...params}>
        {this.state.partners.map(partner => (
          <div key={partner.id}>
            <PartnerBox partner={partner.preview} />
          </div>
        ))}
      </Swiper>
    );  }
};
export default MutipleSlidesPerView;
